import React, { useState } from 'react';
import './buffet.css';
import ChooseBuffetMenu from './choose-buffet-menu';
import { PHONE_NUMBER_WITH_PREFIX } from '../../utils/constants';

const steps = [
  { label: 'Menu Options', component: ChooseBuffetMenu },
];

const BuffetBooking = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [buffetMenu, setBuffetMenu] = useState(null); // Placeholder for next step
  const [error, setError] = useState('');

  const StepComponent = steps[currentStep].component;

  const handleNext = () => {
    setCurrentStep((prev) => prev + 1);
  };

  const handlePrev = () => {
    setCurrentStep((prev) => prev - 1);
  };

  return (
    <div className="step-main-container">
      <div className="step-inner-container">
        <div className="steps-bar">
          <div
            key={steps[currentStep].label}
            className="step-label-new"
          >
            {steps[currentStep].label}
          </div>
        </div>
          <StepComponent
            buffetMenu={buffetMenu}
            setBuffetMenu={setBuffetMenu}
            error={error}
            setError={setError}
            isFirstStep={currentStep === 0}
            isLastStep={currentStep === steps.length - 1}
          />
        <div className="infoNew">
          Note: You can choose your cooking style to be home-style, restaurant-style. Please specify your preference when you call to book.
        </div>
        <div className="infoNote">
          Note: Additional charges will apply for any extra food items or cutlery.
        </div>
      </div>

      <div className="step-button-container">
        {currentStep > 0 && (
          <button
            className="primary-button step-button"
            onClick={handlePrev}
            type="button"
          >
            Previous
          </button>
        )}
        {currentStep === steps.length - 1 ? (
          <a
            href={`tel:${PHONE_NUMBER_WITH_PREFIX}`}
            className="primary-button step-button"
            style={{ textAlign: 'center', textDecoration: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            Click to book
          </a>
        ) : (
          <button
            className="primary-button step-button"
            onClick={handleNext}
            type="button"
          >
            Next
          </button>
        )}
      </div>
    </div>
  );
};

export default BuffetBooking;
